import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import { Tooltip } from 'bootstrap';

const CanceledTicketsReport = () => {
  const [loading, setLoading] = useState(false);
  const [cancelled, setCancelled] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState('');
  const [filterEndDate, setFilterEndDate] = useState('');

  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

  useEffect(() => {
    //getAll();

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl);
    });
  }, []);

  const getAll = async (filters = {}) => {
    setLoading(true);
    try {
      if ($.fn.DataTable.isDataTable('.main')) {
        $('.main').DataTable().destroy();
      }

      const response = await axios.post(ENDPOINT + 'cancel-report', filters);
      setCancelled(response.data.data || []);

      setTimeout(() => {
        $('.main').DataTable({
          searching: true,
          destroy: true,
          retrieve: true,
          pageLength: 50,
          responsive: false,
          autoWidth: false,
          paging: true,
          ordering: true,
          sortable: true,
          processing: false,
          serverSide: false,
          bInfo: true,
          language: {
            "emptyTable": "No hay datos disponibles en la tabla",
            "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
            "infoEmpty": "Mostrando 0 a 0 de 0 registros",
            "infoFiltered": "(filtrado de _MAX_ registros en total)",
            "lengthMenu": "Mostrar _MENU_ registros",
            "loadingRecords": "Cargando...",
            "processing": "Procesando...",
            "search": "Buscar:",
            "zeroRecords": "No se encontraron registros coincidentes",
            "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
            }
          },
          order: [[0, 'desc']]
        });
      }, 100);

    } catch (error) {
      console.error('Error al cargar los registros:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar los registros. Por favor, intente nuevamente.'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = () => {
    const filters = {
      start_date: filterStartDate,
      end_date: filterEndDate
    };
    getAll(filters);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = {
      timeZone: 'America/Mexico_City',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return new Date(dateString).toLocaleString('es-MX', options);
  };

  return (
    <div className="content-wrapper">
      <ContentHeader title="Reporte de Cancelados" />

      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Reporte de Boletos Cancelados</h3>
              <div className="card-tools">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Fecha Inicio</label>
                    <input
                      type="date"
                      className="form-control"
                      value={filterStartDate}
                      onChange={(e) => setFilterStartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Fecha Fin</label>
                    <input
                      type="date"
                      className="form-control"
                      value={filterEndDate}
                      onChange={(e) => setFilterEndDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <button className="btn btn-primary mr-2" onClick={handleFilter}>
                      <i className="fas fa-filter"></i> Filtrar
                    </button>
                    <button
                      className="btn btn-default"
                      onClick={() => {
                        setFilterStartDate('');
                        setFilterEndDate('');
                        getAll();
                      }}
                    >
                      <i className="fas fa-times"></i> Limpiar
                    </button>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-tool"
                  onClick={handleRefresh}
                  data-bs-toggle="tooltip"
                  title="Recargar"
                >
                  <i className="fas fa-sync-alt"></i>
                </button>
              </div>
            </div>

            <div className="card-body">
              <table id="cancelled-table" className="table table-bordered table-striped main">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Fecha de Viaje</th>
                    <th>Horario</th>
                    <th>Estado</th>
                    <th>Vendedor</th>
                    <th>Nota de Cancelación</th>
                    <th>Cancelado por</th>
                    <th>Fecha Cancelación</th>
                  </tr>
                </thead>
                <tbody>
                  {cancelled.map((item) => (
                    <tr key={item.ticket_id}>
                      <td>{item.ticket_id}</td>
                      <td>{item.name}</td>
                      <td>{item.last_name || 'N/A'}</td>
                      <td>{item.date_ticket}</td>
                      <td>{item.schedule?.time || 'N/A'}</td>
                      <td><span className="badge bg-danger">Cancelado</span></td>
                      <td>{item.user_id || 'N/A'}</td> 
                      <td>{item.cancel_note || 'Sin nota'}</td>
                      <td>{item.user_cancel || 'N/A'}</td> 
                      <td>{formatDate(item.date_deleted)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {loading && <Loader />}
    </div>
  );
};

export default CanceledTicketsReport;
